/* eslint-disable import/no-unused-modules */

export const ABTestCookieName = "ssc-ab-test-experiments-ecomm"

// NOTE: add experiment to both arrays
export const experimentIds = [] as const
export const activeExperiments: ABTestExperiment[] = [
    // {
    //     _type: "component",
    //     id: "courtesy-hold-suite-selection-step",
    //     version: 1,
    //     weighting: 0.5,
    // },
    // {
    //     _type: "component",
    //     id: "courtesy-hold-selector-copy",
    //     version: 1,
    //     weighting: 0.5,
    //     enabled: true,
    // },
]

export type ExperimentId = (typeof experimentIds)[number]
export type SegmentId = "a" | "b"

export type ABTestExperiment<TExperimentId = ExperimentId> = {
    _type: "component"
    id: TExperimentId
    version: number
    weighting: number
    enabled: boolean
}

export type ExperimentTag<TExperimentId = ExperimentId> = {
    experimentId: TExperimentId
    segmentId: SegmentId
}

export const isSegmentValid = (value: string): value is SegmentId => ["a", "b"].includes(value)
export const isExperimentEnabled = (experimentId: ExperimentId) =>
    activeExperiments.find((e) => e.id === experimentId)?.enabled ?? false
